export const MAX_EXPORT_RECORDS = 100; 

export const BUSINESS = Object.freeze({
  IFA: 1,
  PRODUCTORES_EXCLUSIVOS: 2,
  CANALES: 3,
  START: 4
});

export const STATUS = {
  OBSERVADO: 2,
  PENDIENTE_PSICO: 70,
  CONTRATO_FIRMADO: 200,
  CONTRATO_MANUAL: 500
}

export const ADD_SUBUSERS_STATUSES = Object.freeze([STATUS.CONTRATO_FIRMADO, STATUS.CONTRATO_MANUAL]);
export const MIN_DATE = "1990-01-01";
export const MIN_DATE_BIRTH = '1900-01-01';

export const BUSINESS_NAME = Object.freeze({
  [BUSINESS.IFA]: "IFA",
  [BUSINESS.PRODUCTORES_EXCLUSIVOS]: "Productores",
  [BUSINESS.CANALES]: "Canales",
  [BUSINESS.START]: "Start"
});

export const getBusinessName = (businessId) =>
  BUSINESS_NAME?.[Number(businessId)] ?? "-";

const NEXT_BUSINESS = Object.freeze({
  [BUSINESS.IFA]: BUSINESS.CANALES,
  [BUSINESS.CANALES]: BUSINESS.IFA,
});

export const getNextBusinessName = (businessId) => {
  const nextId = NEXT_BUSINESS[Number(businessId)];
  return nextId ? BUSINESS_NAME[nextId] : "-";
};

export const BUSINESS_CANDIDATES_TITLE = Object.freeze({
  [BUSINESS.IFA]: "Candidatos a IFA",
  [BUSINESS.PRODUCTORES_EXCLUSIVOS]: "Candidatos Productores",
  [BUSINESS.CANALES]: "Candidatos Canales",
  [BUSINESS.START]: "Candidatos Start"
});

export const getCandidatesTitle = (businessId) =>
  BUSINESS_CANDIDATES_TITLE?.[Number(businessId)] ?? "Candidatos";

export const ROLE = Object.freeze({
  EQ_COMERCIAL: 1,
  SOP_COMERCIAL: 2,
  COMPLIANCE: 3,
  ALL: 4,
  EQ_COMERCIAL_ASISTENTE: 5,
  AMALIA: 6,
  ASISTENTE_EMBAJADOR: 7,
  EQ_COMERCIAL_LIDER: 15,
  RRHH: 16,
  EQ_COMERCIAL_VIEWER: 17,
  EQ_TEAM_LEADER: 18
});

export const ROLE_LABEL = Object.freeze({
  [ROLE.EQ_COMERCIAL]: "EC - Asesor",
  [ROLE.EQ_COMERCIAL_ASISTENTE]: "EC - Asistente",
  [ROLE.EQ_COMERCIAL_LIDER]: "EC - Director",
  [ROLE.SOP_COMERCIAL]: "Soporte Comercial",
  [ROLE.COMPLIANCE]: "Compliance",
  [ROLE.ALL]: "All",
  [ROLE.AMALIA]: "Amalia",
  [ROLE.ASISTENTE_EMBAJADOR]: "Soporte Comercial Facultades Ampliadas",
  [ROLE.RRHH]: 'RRHH',
  [ROLE.EQ_COMERCIAL_VIEWER]: 'EC - Asesor Visibilidad Expandida',
  [ROLE.EQ_TEAM_LEADER]: 'EC - Team Leader'
});

export const getRoleLabel = (roleId) =>
  ROLE_LABEL?.[Number(roleId)] ?? `Rol ${roleId}`;

export const ROLE_OPTIONS = Object.freeze(
  [
    ROLE.COMPLIANCE,
    ROLE.ALL,
    ROLE.EQ_COMERCIAL,
    ROLE.EQ_COMERCIAL_ASISTENTE,
    ROLE.EQ_COMERCIAL_VIEWER,
    ROLE.EQ_COMERCIAL_LIDER,
    ROLE.EQ_TEAM_LEADER,
    ROLE.SOP_COMERCIAL,
    ROLE.ASISTENTE_EMBAJADOR,
    ROLE.RRHH,
  ].map((roleId) => ({
    value: roleId,
    label: ROLE_LABEL[roleId],
  }))
);

export const CREATE_PRODUCTOR_ROLES = Object.freeze([ROLE.SOP_COMERCIAL, ROLE.ASISTENTE_EMBAJADOR]);
export const CREATE_SUBUSERS_ROLES = Object.freeze([ROLE.SOP_COMERCIAL, ROLE.ASISTENTE_EMBAJADOR]);

export const THROTTLE_TIME_TEN_MINUTES = 10 * 60 * 1000;
export const THROTTLE_TIME_TEN_SECONDS = 10 * 1000;

export const ADVANCE_STATUS = {
    AVANZA: 1,
    AVANZA_RESERVAS: 2,
    NO_AVANZA: 3,
}

export const CONTRATOS = {
  CANALES_PRODUCTOR: 10,
  CANALES_REFERENCIADOR: 11,
  CANALES_RETRO_FIJA_PRODUCTOR: 12,
  CANALES_RETRO_FIJA_REFERENCIADOR: 13,
}

export const listFilter = [
  {
      id: 1,
      prospect: 'PRE-CANDIDATO',
      name:"PRE-CANDIDATO",
      status_id: '1',
  },
  {
      id: 10,
      prospect: 'OBSERVADO',
      name: 'OBSERVADO',
      status_id: '2',
  },
  {
      id: 11,
      prospect: 'CONTACTADO',
      name: 'CONTACTADO',
      status_id: '3',
  }, {
      id: 2,
      prospect: 'EQUIPO COMERCIAL',
      name: 'EQUIPO COMERCIAL',
      status_id: '30,31',
  }, {
      id: 3,
      prospect: 'SOPORTE COMERCIAL',
      name: 'SOPORTE COMERCIAL',
      status_id: '40',
  }, {
      id: 4,
      prospect: 'COMPLIANCE',
      name: 'COMPLIANCE',
      status_id: '50,60',
  },
  {
      id: 12,
      prospect: 'PENDIENTE PSICOTECNICO',
      name: 'PENDIENTE PSICOTECNICO',
      status_id: '70',
  },
  {
      id: 5,
      prospect: 'PENDIENTE ENVIO CONTRATO',
      name: 'PENDIENTE ENVIO CONTRATO',
      status_id: '100',
  }, {
      id: 6,
      prospect: 'PENDIENTE FIRMA',
      name: 'PENDIENTE FIRMA',
      status_id: '102',
  }, {
      id: 7,
      prospect: 'CONTRATO FIRMADO',
      name: 'CONTRATO FIRMADO',
      status_id: '200',
  },
  {
      id: 8,
      prospect: 'CONTRATO RECHAZADO',
      name: 'CONTRATO RECHAZADO ',
      status_id: '300',
  },
  {
      id: 10,
      prospect: 'CONTRATO ANULADO',
      name: 'CONTRATO ANULADO ',
      status_id: '301',
  },
  {
    id: 13, 
    prospect: 'CONTRATO MANUAL',
    name: 'CONTRATO MANUAL',
    status_id: 500
  },
  {
      id: 9,
      prospect: 'RECHAZADO',
      name: 'USUARIO RECHAZADO',
      status_id: '28,29,48,49,58,59',
  }
]